import { isAnyArray } from 'is-any-array';
import { ChromatogramSeries1D } from "./chromatogram_series_1d.js";
import { ChromatogramSeries2D } from "./chromatogram_series_2d.js";
export function seriesFromArray(array, options) {
    if (!isAnyArray(array)) {
        throw new TypeError('seriesFromArray requires as parameter an array of numbers or arrays');
    }
    if (typeof array[0] === 'number') {
        return new ChromatogramSeries1D(array, options);
    }
    if (!isAnyArray(array[0]) ||
        !isAnyArray(array[0][0]) ||
        !isAnyArray(array[0][1])) {
        throw new TypeError('seriesFromArray requires as parameter an array of numbers or array');
    }
    return new ChromatogramSeries2D(array, options);
}
//# sourceMappingURL=series_from_array.js.map